// extracted by mini-css-extract-plugin
module.exports = {"select":"select--1OPjs","select__icon":"select__icon--2sEQ7","select__text":"select__text--1N_Yb","open":"open--_WdN2"};